(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsBulkActionSidebar', rmsBulkActionSideBar);

    function rmsBulkActionSideBar($timeout, lodash, $filter) {
        return {
            restrict: 'E',
            link: rmsBulkActionSideBarLink,
            templateUrl: 'common/app/components/list-filter/sidebar-bulk-action'
        };

        function rmsBulkActionSideBarLink(scope, elem) {
            scope.listFilterService = scope.$parent.listFilterService;
            scope.filterViewWrapperStyle = {bottom: 0};

            var vm = scope.$parent.vm;
            vm.bulkActions = {};

            vm.bulkActions.allowed_select_all_buttons = lodash.get(vm, 'pageData.toolbar.allowed_select_all_button', []);
            vm.bulkActions.hasSelectAll = showSelectAll();
            vm.bulkActions.filterCount = vm.pageData.grid.dataSource.total();

            scope.$watch(function () {
                return vm.pageData.toolbar.selection.selected.length;
            }, getSelectedCount);


            vm.bulkActions.toggleSelectAll = function() {
                vm.pageData.toolbar.selection.select_all = !vm.pageData.toolbar.selection.select_all;
                vm.pageData.toolbar.selection.selection_count = (vm.pageData.toolbar.selection.select_all)
                    ? vm.bulkActions.filterCount
                    : vm.pageData.toolbar.selection.selected.length;
                // vm.bulkActions.select_all = !vm.bulkActions.select_all;
                vm.bulkActions.determineBulkActionButtons();
            }

            vm.bulkActions.hideSidebar = function () {
                scope.listFilterService.clearSelected();
                vm.pageData.toolbar.selection.select_all = false;
                $timeout(function () {
                    vm.pageData.grid.resize();
                });
            };

            vm.bulkActions.determineBulkActionButtons = function () {
                var allowedButtons, currentPipelineValue, bulkActionRules, pipelineData, currentPipeline;
                var selectionButtons = lodash.get(vm, 'pageData.toolbar.selection.buttons') || [];
                var additionalButtons = lodash.get(vm, 'pageData.toolbar.selection.additionals[0].actions') || [];
                var bulkActionButtons = selectionButtons.concat(additionalButtons);
                var hasPipeline = scope.listFilterService.getHasPipeline();

                if (vm.pageData.toolbar.selection.select_all) {
                    bulkActionButtons = lodash.filter(bulkActionButtons, function(button) {
                        return vm.bulkActions.allowed_select_all_buttons.indexOf(button.button_id) >= 0;
                    });
                }

                if (hasPipeline === true) {
                    pipelineData = scope.listFilterService.getPipelineData();
                    currentPipeline = scope.listFilterService.getCurrentPipeline();
                    bulkActionRules = lodash.reduce(pipelineData, function (carry, pipeline) {
                        pipeline.value.forEach(function (value) {
                            carry[value] = pipeline.bulk_actions;
                        });
                        return carry;
                    }, {});

                    currentPipelineValue = lodash.head(lodash.get(currentPipeline, '0.value', []));
                    allowedButtons = lodash.get(bulkActionRules, currentPipelineValue) || [];

                    // if bulk_actions set in pipeline status is true, allow all buttons
                    if (allowedButtons === true) {
                        vm.bulkActions.bulk_action_buttons = bulkActionButtons;
                    }
                    // else determine if there are matching button_ids
                    else if (allowedButtons.length > 0) {
                        vm.bulkActions.bulk_action_buttons = bulkActionButtons.filter(function (button) {
                            return allowedButtons.some(function (allowed) {
                                return allowed === button.button_id;
                            })
                        });
                    } else {
                        vm.bulkActions.bulk_action_buttons = [];
                    }


                } else {
                    // if page doesn't have pipeline, return all buttons.
                    vm.bulkActions.bulk_action_buttons = bulkActionButtons;
                }
            };

            vm.bulkActions.getSelectAllLabel = function() {
                return $filter('stringFormat')(vm.pageData.toolbar.selection.label.select_all, [vm.bulkActions.filterCount]);
            }
            vm.bulkActions.getSelectAllRemarkLabel = function() {
                return $filter('stringFormat')(vm.pageData.toolbar.selection.label.select_all_remark, [vm.bulkActions.filterCount]);
            }

            vm.bulkActions.closeAndOpenFilters = function () {
                vm.bulkActions.hideSidebar();
                vm.expandSidebar();
            };

            function getSelectedCount() {
                vm.bulkActions.selected_count = $filter('stringFormat')(vm.pageData.toolbar.selection.label.selected_count, [vm.bulkActions.filterCount]);
                vm.bulkActions.selected_all_count = $filter('stringFormat')(vm.pageData.toolbar.selection.label.selected_count, [vm.pageData.toolbar.selection.selected.length]);
            }

            // run button filter
            vm.bulkActions.determineBulkActionButtons();

            function showSelectAll() {
                var totalPages = vm.pageData.grid.dataSource.totalPages();
                var actionCounts = vm.bulkActions.allowed_select_all_buttons.length || 0;
                var hasSelectAll = lodash.get(vm, 'pageData.toolbar.hasSelectAll', false);
                if (hasSelectAll) {
                    return ((totalPages > 1) && (actionCounts > 0));
                }
            }

        }
    }
})();